import EmailLogin from "./emailLogin";

export default EmailLogin;